const If = ({ condtion, children }) => {
  if(typeof children === "function" && !!condition) {
    return children();
  }

  if(Array.isArray(children) && !!condition) {
    return children;
  }

  return null;
}

export default If;



// WEBPACK FOOTER //
// ./src/components/if.js